import { Box } from '@palmetto/palmetto-components';

import { DIFF_IDENTITY_KEY, ProgramType, ProgramTypeLabels } from 'types';

import { Diffs } from './Diffs';
import EventBy from './EventBy';

const NO_HIDDEN_PROPERTIES: string[] = [];

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : undefined;

// The backend identifies a license by `STATE:programType`, with a `#n` suffix on repeats of the same pair.
// Either part can be absent (placeholder licenses have a blank state and no program type).
const formatIdentity = (identity: string): string => {
  const [pair, ordinal] = identity.split('#');
  const [state, programType] = pair.split(':');
  const hasProgramType = Boolean(programType) && programType !== 'undefined' && programType !== 'null';
  const programLabel = hasProgramType ? (ProgramTypeLabels[programType as ProgramType] ?? programType) : '';
  const base = [state, programLabel].filter(Boolean).join(' ');
  return base && ordinal ? `${base} #${ordinal}` : base;
};

const getLabel = (diff: unknown): string => {
  const licensesDiff = asRecord(diff)?.licenses;
  if (!Array.isArray(licensesDiff)) {
    return '';
  }
  return licensesDiff
    .map((element) => asRecord(element)?.[DIFF_IDENTITY_KEY])
    .filter((identity): identity is string => typeof identity === 'string' && identity.length > 0)
    .map(formatIdentity)
    .filter(Boolean)
    .join(', ');
};

const SabalOrganizationLicensesUpdated = ({ event }: { event: any }) => {
  const foundLabel = getLabel(event?.data?.diff);
  const label = `${foundLabel ? `${foundLabel} ` : ''}License`;
  return (
    <Box display="block">
      <EventBy event={event} /> updated
      <br />
      <strong>{label}</strong>
      <br />
      <Diffs diff={event?.data?.diff} hiddenProperties={NO_HIDDEN_PROPERTIES} hideInitialNulls />
    </Box>
  );
};

export default SabalOrganizationLicensesUpdated;
